function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Leaderboard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Pagination = require("../Pagination");
var _View = require("../View");
var _ActivityIndicator = require("../ActivityIndicator");
var _styles = require("./styles");
var _Avatar = require("./elements/Avatar");
var _Badge = require("./elements/Badge");
var _Points = require("./elements/Points");
var _Change = require("./elements/Change");
var _Options = require("./elements/Options");
var _Indicators = require("./elements/Indicators");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var RowContainer = (0, _react.memo)(function (_ref) {
  var children = _ref.children;
  if (_reactNative.Platform.OS === 'web') {
    return (0, _jsxRuntime.jsx)("div", {
      translate: "no",
      children: children
    });
  }
  return (0, _jsxRuntime.jsx)(_View.View, {
    children: children
  });
});
var Leaderboard = exports.Leaderboard = (0, _react.memo)(function (_ref2) {
  var options = _ref2.options,
    pagination = _ref2.pagination,
    columns = _ref2.columns,
    rows = _ref2.rows,
    sort = _ref2.sort,
    filter = _ref2.filter,
    onPaginationPress = _ref2.onPaginationPress,
    isLoading = _ref2.isLoading,
    downloadUrl = _ref2.downloadUrl;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasRows = rows && rows.length > 0;
  var _topIndicators = (0, _react.useMemo)(function () {
    var _options$indicators;
    return options == null ? void 0 : (_options$indicators = options.indicators) == null ? void 0 : _options$indicators.filter(function (item) {
      return (pagination == null ? void 0 : pagination.current) && item.page < pagination.current;
    });
  }, [options == null ? void 0 : options.indicators, pagination]);
  var _bottomIndicators = (0, _react.useMemo)(function () {
    var _options$indicators2;
    return options == null ? void 0 : (_options$indicators2 = options.indicators) == null ? void 0 : _options$indicators2.filter(function (item) {
      return (pagination == null ? void 0 : pagination.current) && item.page > pagination.current;
    });
  }, [options == null ? void 0 : options.indicators, pagination]);
  var _filteredColumns = (0, _react.useMemo)(function () {
    return columns == null ? void 0 : columns.filter(function (item) {
      return !item.filterable || item.filterable.id === (filter == null ? void 0 : filter.selectedId);
    });
  }, [columns, filter]);
  var _renderCustomComponent = function _renderCustomComponent(cell) {
    var _cell$value, _cell$secondary_value;
    switch (cell.type || cell.id) {
      case 'avatar':
        return (0, _jsxRuntime.jsx)(_Avatar.LeaderboardAvatar, {
          value: cell == null ? void 0 : (_cell$value = cell.value) == null ? void 0 : _cell$value.toString(),
          showCrown: cell == null ? void 0 : cell.is_first,
          label: cell == null ? void 0 : cell.label
        });
      case 'badge_trying':
        return (0, _jsxRuntime.jsx)(_Badge.LeaderboardBadge, {
          value: Number(cell.value),
          type: "trying"
        });
      case 'badge_completed':
        return (0, _jsxRuntime.jsx)(_Badge.LeaderboardBadge, {
          value: Number(cell.value),
          type: "completed"
        });
      case 'score':
        return (0, _jsxRuntime.jsx)(_Points.LeaderboardPoints, {
          value: Number(cell.value),
          unit: cell == null ? void 0 : cell.unit
        });
      case 'change':
        return (0, _jsxRuntime.jsx)(_Change.LeaderboardChange, {
          value: Number(cell.value),
          unit: cell == null ? void 0 : cell.unit
        });
      case 'rank':
        return (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: styles.rank,
          testID: "LeaderboardRank",
          children: t('format:number', {
            value: cell.value
          })
        });
      default:
        return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.rowCellText,
            textBreakStrategy: "simple",
            children: cell.value
          }), cell == null ? void 0 : (_cell$secondary_value = cell.secondary_values) == null ? void 0 : _cell$secondary_value.map(function (value, index) {
            return (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.rowCellSecondaryText,
              textBreakStrategy: "simple",
              children: value
            }, index);
          })]
        });
    }
  };
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: styles.leaderboardWrapper,
    testID: "Leaderboard",
    children: [(0, _jsxRuntime.jsx)(_Options.LeaderboardOptions, {
      sort: sort,
      filter: filter,
      downloadUrl: downloadUrl
    }), (options == null ? void 0 : options.heading) && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.leaderboardHeading,
      children: options == null ? void 0 : options.heading
    }), isLoading && (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.loading,
      children: (0, _jsxRuntime.jsx)(_ActivityIndicator.ActivityIndicator, {})
    }), !isLoading && !_hasRows && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.emptyMessage,
      testID: "LeaderboardEmptyMessage",
      children: t('leaderboard:emptyMessage')
    }), !isLoading && _hasRows && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_View.View, {
        style: styles.columnHeadings,
        testID: "LeaderboardHeadings",
        children: _filteredColumns == null ? void 0 : _filteredColumns.map(function (column, index) {
          var _column$sortable, _column$sortable2;
          var activeSortColumn = !!((_column$sortable = column.sortable) != null && _column$sortable.id) && ((_column$sortable2 = column.sortable) == null ? void 0 : _column$sortable2.id) == (sort == null ? void 0 : sort.selectedId);
          return (0, _jsxRuntime.jsxs)(_View.View, {
            style: [styles.columnHeading, styles.individualHeadingStyle[column.id]],
            children: [activeSortColumn && (0, _jsxRuntime.jsx)(_View.View, {
              style: styles.defaultSortColumnStyling
            }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: [styles.columnHeadingTitle, index === 0 ? styles.columnHeadingTitleFirst : {}],
              children: column.label
            }), (column == null ? void 0 : column.sub_label) && (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.columnHeadingSubTitle,
              children: column.sub_label
            })]
          }, column.id);
        })
      }), (0, _jsxRuntime.jsx)(_View.View, {
        style: styles.rowContainer,
        children: (0, _jsxRuntime.jsxs)(RowContainer, {
          children: [(pagination == null ? void 0 : pagination.visible) && (0, _jsxRuntime.jsx)(_Indicators.LeaderboardIndicators, {
            items: _topIndicators,
            position: _Indicators.LeaderboardIndicatorPosition.top,
            onPress: onPaginationPress
          }), (0, _jsxRuntime.jsx)(_View.View, {
            style: styles.rows,
            testID: "LeaderboardRows",
            children: rows == null ? void 0 : rows.map(function (row, index) {
              var _row$rowValues;
              var _isHighlighted = row.highlighted;
              var _isFinalRow = !_isHighlighted && rows.length - 1 === index;
              return (0, _jsxRuntime.jsxs)(_View.View, {
                style: [styles.row, _isFinalRow && styles.finalRow],
                children: [_isHighlighted && (0, _jsxRuntime.jsx)(_View.View, {
                  style: styles.highlightedRow
                }), row == null ? void 0 : (_row$rowValues = row.rowValues) == null ? void 0 : _row$rowValues.map(function (cell) {
                  var _label = _filteredColumns == null ? void 0 : _filteredColumns.find(function (column) {
                    return column.id === cell.id;
                  });
                  var _isActiveSortColumn = !!cell.sort_id && cell.sort_id == (sort == null ? void 0 : sort.selectedId);
                  if (!!cell.filter_id && filter && cell.filter_id !== (filter == null ? void 0 : filter.selectedId)) {
                    return null;
                  }
                  return (0, _jsxRuntime.jsxs)(_View.View, {
                    style: [styles.rowCell, styles.individualCellStyle[cell.id]],
                    children: [_isActiveSortColumn && (0, _jsxRuntime.jsx)(_View.View, {
                      style: [styles.defaultSortColumnCellStyling, _isHighlighted && styles.defaultSortColumnCellStyling_highlighted]
                    }), (_label == null ? void 0 : _label.label) && (0, _jsxRuntime.jsxs)(_View.View, {
                      style: [styles.rowCellHeading, styles.individualRowCellHeading[cell.id]],
                      children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                        style: [styles.rowCellHeadingTitle],
                        children: _label.label
                      }), (_label == null ? void 0 : _label.sub_label) && (0, _jsxRuntime.jsx)(_reactNative.Text, {
                        style: styles.rowCellHeadingSubTitle,
                        children: _label.sub_label
                      })]
                    }), (0, _jsxRuntime.jsx)(_View.View, {
                      style: styles.rowCellContent,
                      children: _renderCustomComponent(cell)
                    })]
                  }, cell.id);
                })]
              }, index);
            })
          }), (pagination == null ? void 0 : pagination.visible) && (0, _jsxRuntime.jsx)(_Indicators.LeaderboardIndicators, {
            items: _bottomIndicators,
            position: _Indicators.LeaderboardIndicatorPosition.bottom,
            onPress: onPaginationPress
          })]
        })
      })]
    }), (pagination == null ? void 0 : pagination.visible) && (0, _jsxRuntime.jsx)(_Pagination.Pagination, {
      style: styles.pagination,
      currentItem: pagination.current - 1,
      totalItems: pagination.last,
      label: t('leaderboard:pagination'),
      showEllipsis: true,
      isNumbered: true,
      onPress: function onPress(index) {
        return onPaginationPress == null ? void 0 : onPaginationPress(index + 1);
      }
    })]
  });
});